export default __webpack_public_path__ + "static/media/booth_4_marigold.eadf1e88.png";